module.exports = __webpack_public_path__ + "static/media/edu.915c79f0.svg";